import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-client-highest-tickets',
  templateUrl: './client-highest-tickets.component.html',
  styleUrls: ['./client-highest-tickets.component.css']
})
export class ClientHighestTicketsComponent implements OnInit {

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.ClientsHighestTickets();
  }

  ClientsHighestTickets = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.clientsHighestTickets()
    .subscribe((data:any)=>{
      this.ClientList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}

}



// WEBPACK FOOTER //
// ./src/app/reports/client-highest-tickets/client-highest-tickets.component.ts